// Soanari · tienda: barra de apartados fija, filtro instantáneo (en «Ver todas») y «Añadir a la cesta».
// El botón usa el mismo evento que la ficha (CartLinesUpdateEvent), así la cesta se repinta sola.
import { CartLinesUpdateEvent } from '@shopify/events';

const s = document.querySelector('.sn-tienda');
if (s && !s.dataset.ok) {
  s.dataset.ok = '1';
  const bar = s.querySelector('.sn-cats');

  // La barra se queda pegada justo debajo de la cabecera
  const fija = () => {
    if (!bar) return;
    const h = document.querySelector('#header-group, .header-section, header');
    const r = h?.getBoundingClientRect();
    bar.style.top = (r && getComputedStyle(h).position !== 'static' ? Math.max(0, r.bottom) : 0) + 'px';
  };
  fija();
  addEventListener('resize', fija, { passive: true });
  addEventListener('scroll', fija, { passive: true });

  // La pestaña activa siempre visible en móvil
  bar?.querySelector('[aria-pressed="true"], [aria-current="page"]')?.scrollIntoView({ inline: 'center', block: 'nearest' });

  // Filtro instantáneo por apartado (solo en «Ver todas», donde los apartados son botones)
  const pon = (cat) => {
    s.querySelectorAll('button.sn-cats__b').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cat === cat)));
    s.querySelectorAll('.sn-grupo').forEach((g) => (g.hidden = cat !== 'todas' && g.dataset.cat !== cat));
    const y = s.querySelector('.sn-cats').getBoundingClientRect().top + window.scrollY - (parseFloat(bar.style.top) || 0);
    if (window.scrollY > y) window.scrollTo({ top: y, behavior: 'smooth' });
    bar.querySelector('[aria-pressed="true"]')?.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
  };
  s.querySelectorAll('button.sn-cats__b').forEach((b) => b.addEventListener('click', () => pon(b.dataset.cat)));

}

// Añadir a la cesta con el mismo flujo que la ficha de producto (tienda, apartados, sugerencias y regalo de la cesta).
// data-sn-add = una variante; data-sn-add-pack = varias separadas por comas (el pack de la ficha).
if (!window.__snAdd) {
  window.__snAdd = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-sn-add], [data-sn-add-pack]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    // Botones con icono (tarjetas): el texto va en su <span>; los demás, en el propio botón
    const icono = btn.hasAttribute('data-sn-icon');
    const lbl = icono ? btn.querySelector('span') : btn;
    const txt = lbl ? lbl.textContent : '';
    if (lbl) lbl.textContent = 'Añadiendo…';
    btn.classList.add('is-busy');
    const ids = (btn.dataset.snAddPack || btn.dataset.snAdd).split(',').filter(Boolean);
    const secciones = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const diferido = CartLinesUpdateEvent.createPromise();
    btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: ids.map((id) => ({ merchandiseId: id, quantity: 1 })), promise: diferido.promise }));
    try {
      const r = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })), sections: secciones.join(',') })
      });
      const resp = await r.json();
      const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      diferido.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'sn-tienda', sourceId: 'sn-tienda', itemCount: ids.length, sections: resp.sections, didError: !!resp.status }
      });
      if (lbl) lbl.textContent = resp.status ? resp.description || 'No disponible' : 'Añadido ✓';
      btn.classList.toggle('is-ok', !resp.status);
      // El regalo que se pone solo no abre la cesta (si ya está abierta, se ve entrar)
      if (!resp.status && !btn.hasAttribute('data-sn-auto-regalo')) {
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        for (let i = 0; i < 25; i++) {
          const ci = document.querySelector('#cart-drawer cart-items-component');
          if (ci && !ci.querySelector('[data-cart-drawer-empty]') && ci.querySelector('[data-key], .cart-items__table-row')) break;
          await new Promise((res) => setTimeout(res, 120));
        }
        if (!drawer?.isOpen) drawer?.open?.();
      }
    } catch (err) {
      diferido.reject(err);
      if (lbl) lbl.textContent = 'Inténtalo de nuevo';
    }
    setTimeout(() => {
      if (lbl) lbl.textContent = txt;
      btn.classList.remove('is-busy', 'is-ok');
      btn.disabled = false;
    }, 1800);
  });
}

// Fotos deslizables de las tarjetas: flechas (ordenador) y puntitos que siguen al dedo (móvil)
if (!window.__snFotos) {
  window.__snFotos = true;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sn-dir]');
    if (!b) return;
    e.preventDefault();
    const s = b.closest('.sn-card__img')?.querySelector('[data-sn-slides]');
    if (!s) return;
    const n = s.children.length, w = s.clientWidth, i = Math.round(s.scrollLeft / w);
    const j = (i + Number(b.dataset.snDir) + n) % n;
    s.scrollTo({ left: j * w, behavior: 'smooth' });
  });
  document.addEventListener('scroll', (e) => {
    const s = e.target;
    if (!(s instanceof Element) || !s.matches('[data-sn-slides]')) return;
    const i = Math.round(s.scrollLeft / s.clientWidth);
    s.parentElement.querySelectorAll('.sn-card__dots i').forEach((d, k) => d.classList.toggle('on', k === i));
  }, { capture: true, passive: true });
}

// Cesta por encima de la web: pulsar en la zona oscurecida la cierra
if (!window.__snFuera) {
  window.__snFuera = true;
  document.addEventListener('click', (e) => {
    const w = e.target;
    if (w instanceof Element && w.classList.contains('page-wrapper--drawer-open')) document.querySelector('theme-drawer#cart-drawer')?.close?.();
  });
}

// Menú: las fotos de «Regalos por ocasión» y «Velas» se precargan en cuanto la página está lista,
// así el desplegable sale con sus fotos al momento (antes solo empezaban a bajar al pasar el ratón)
if (!window.__snMenu) {
  window.__snMenu = true;
  const precarga = () => document.querySelectorAll('header img[loading="lazy"]').forEach((i) => i.removeAttribute('loading'));
  if ('requestIdleCallback' in window) requestIdleCallback(precarga, { timeout: 2500 }); else setTimeout(precarga, 1500);
}

// Pack de la ficha (snippets/sn-pack.liquid): al elegir otra pieza, cambian la foto, el nombre, los precios
// y lo que añade el botón. El 10 % lo pone Shopify en la cesta (descuento automático de la línea).
if (!window.__snPack) {
  window.__snPack = true;
  document.addEventListener('click', (e) => {
    const op = e.target.closest('[data-sn-pack] .sn-pack__op');
    if (!op) return;
    const pk = op.closest('[data-sn-pack]');
    const eur = (c) => (c / 100).toFixed(2).replace('.', ',') + ' €';
    const total = Number(pk.dataset.base) + Number(op.dataset.precio);
    const ahora = Math.floor((total * 90) / 100);
    pk.querySelectorAll('.sn-pack__op').forEach((b) => b.setAttribute('aria-checked', String(b === op)));
    pk.querySelectorAll('[data-sn-pack-enlace]').forEach((a) => (a.href = op.dataset.url));
    const img = pk.querySelector('a.sn-pack__pieza img');
    if (img) { img.removeAttribute('srcset'); img.src = op.dataset.img; img.alt = op.dataset.titulo; }
    pk.querySelector('[data-sn-pack-nombre]').textContent = op.dataset.titulo;
    pk.querySelector('[data-sn-pack-su-precio]').textContent = eur(op.dataset.precio);
    pk.querySelector('[data-sn-pack-antes]').textContent = eur(total);
    pk.querySelector('[data-sn-pack-ahora]').textContent = eur(ahora);
    pk.querySelector('[data-sn-pack-envio]').hidden = ahora < 5000;
    const btn = pk.querySelector('[data-sn-add-pack]');
    btn.dataset.snAddPack = pk.dataset.baseId + ',' + op.dataset.id;
    btn.disabled = false; btn.classList.remove('is-ok', 'is-busy'); btn.textContent = 'Añadir las 2 a la cesta';
  });
}

// Regalo automático (24 oct): con 50 € o más (sin pack), la cesta pinta «Añadir mi regalo» con data-sn-auto-regalo
// y aquí se pulsa solo, una vez por visita. Si el cliente lo quita, no se vuelve a poner (le queda el botón).
// Si el aromatizante que pusimos deja de salir gratis (la cesta baja de 50 €), se quita solo.
if (!window.__snRegalo) {
  window.__snRegalo = true;
  const K = 'sn_regalo_auto';
  const leer = () => { try { return sessionStorage.getItem(K); } catch (e) { return 'x'; } };
  const poner = (v) => { try { v ? sessionStorage.setItem(K, v) : sessionStorage.removeItem(K); } catch (e) {} };
  document.addEventListener('click', (e) => { if (e.isTrusted && e.target.closest('.sn-envio__btn')) poner('puesto'); }, true);
  let t;
  const revisar = () => {
    const q = document.querySelector('[data-sn-quitar-regalo]');
    if (q && leer() === 'puesto') {
      const fila = document.querySelector('#cart-drawer [data-key="' + q.dataset.snQuitarRegalo + '"]');
      const quitar = fila?.querySelector('.cart-items__remove');
      if (quitar && !fila.classList.contains('removing')) { q.remove(); poner(''); quitar.click(); }
      return;
    }
    const b = document.querySelector('[data-sn-auto-regalo]');
    if (b && !b.disabled && !leer()) { poner('puesto'); b.click(); }
  };
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(revisar, 300); }).observe(document.body, { childList: true, subtree: true });
  setTimeout(revisar, 800);
}
